import { useState, useEffect } from 'react';
import { fetchClientCodes, fetchCarrierCodes } from '../services/api';

export const useStaticData = () => {
  const [data, setData] = useState({
    clientCodes: [],
    carrierCodes: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        const [clientsData, carriersData] = await Promise.all([
          fetchClientCodes(),
          fetchCarrierCodes(),
        ]);

        if (!cancelled) {
          setData({
            clientCodes: clientsData.map(client => client.client_code),
            carrierCodes: carriersData,
            loading: false,
            error: null,
          });
        }
      } catch (error) {
        if (!cancelled) {
          console.error('Erreur lors du chargement des données statiques:', error);
          setData(prev => ({
            ...prev,
            loading: false,
            error: error.message,
          }));
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  return data;
};
